export default "__VITE_ASSET__DGzVdxTj__"